import React, { useState, useEffect } from "react";
import { Container } from "react-bootstrap";
import { fetchPublicCategories } from "api/auth";
import "./CategoriesSection.scss";
import { PublicCategory } from "interfaces/ICategory";
import { useBreakpoints } from "hooks/useBreakPoints";
import { primaryColor } from "utils/colors";
import stars from "assets/estrellitas.png";
import { useNavigate } from "react-router-dom";

const CategoriesSection: React.FC = () => {
  const [categories, setCategories] = useState<PublicCategory[]>([]);
  const { isMobile } = useBreakpoints();
  const navigate = useNavigate();

  /**
   * Effect hook to fetch and load public categories on component mount
   * @effect
   * @dependencies []
   *
   * Makes API call to get categories and updates state
   * Handles error cases with console logging
   */
  useEffect(() => {
    const loadCategories = async () => {
      try {
        const response = await fetchPublicCategories();
        setCategories(response);
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };

    loadCategories();
  }, []);

  /**
   * Handles navigation to search page with selected category
   * @param {number} categoryId - The ID of the category to filter by
   */
  const handleCategoryClick = (categoryId: number) => {
    // Scroll hacia arriba antes de navegar
    window.scrollTo({ top: 0, behavior: 'smooth' });
    
    // Pequeño delay para que el scroll se ejecute antes de navegar
    setTimeout(() => {
      navigate(`/search?categories=${categoryId}`);
    }, 300);
  };

  return (
    <Container fluid className="categories-section">
      <div className="categories-grid">
        {categories.slice(0, isMobile ? 4 : 8).map((category) => (
          <div 
            key={category.id} 
            className="category-card"
            onClick={() => handleCategoryClick(category.id)}
            style={{ cursor: 'pointer' }}
          >
            <div className="image-container">
              <img src={category.images[0]} alt={category.name} />
            </div>
            <div className="category-name">
              <h3>{category.name}</h3>
            </div>
          </div>
        ))}
      </div>
      <div
        className="d-flex align-items-center justify-content-center"
        style={{ margin: "20px 0 0 0" }}
      >
        {!isMobile && (
          <div
            style={{
              height: "1px",
              background: primaryColor,
              flex: 1,
              maxWidth: "32%",
              boxShadow: "2px 4px 3px rgba(0,0,0,0.6)",
            }}
          />
        )}
        <h1
          style={{
            color: "black",
            fontWeight: "bold",
            fontSize: isMobile ? "40px" : "64px",
            letterSpacing: "3%",
            display: "flex",
            alignItems: "center",
            marginLeft: isMobile ? "3rem" : "4rem",
          }}
        >
          TENDENCIA
        </h1>
        <img
          src={stars}
          alt="estrella"
          style={{
            width: isMobile ? "3rem" : "4rem",
            height: isMobile ? "3rem" : "4rem",
            verticalAlign: "middle",
          }}
        />
        {!isMobile && (
          <div
            style={{
              height: "1px",
              background: primaryColor,
              flex: 1,
              maxWidth: "32%",
              boxShadow: "2px 4px 3px rgba(0,0,0,0.6)",
            }}
          />
        )}
      </div>
    </Container>
  );
};

export default CategoriesSection;
